





















import VueNumeric from './VueNumeric.vue'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component({
  components: {
    VueNumeric
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    currency: {
      type: String,
      default: '$'
    },
    minus: {
      type: Boolean,
      default: true
    },
    precision: {
      type: Number,
      default: 2
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '0.00',
      required: false
    }
  }
})
export default class MoneyInputV3 extends Vue {
  isError: boolean = false

  emitInput (value: any) {
    if (this.$props.required) {
      this.isError = !value
    }
    this.$emit('input', value)
  }

  emit (eventName: string, e: any) {
    this.$emit(eventName, e)
  }

  mounted () {
    this.emitInput(this.$props.value)
  }
}
